import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { AlphaTextFieldValidator } from '../../../validations/alpha-text-field-validator'
//import { AddressDB } from '../../../user-management/models/Address'
import { FieldValidator } from '../../../validations/field-validator'
import { NotPoBoxAddressTextFieldValidator } from '../../../validations/not-po-box-address-text-field-validator'
import { Validatable } from '../../../validations/validatable'
import { FormValidationService } from '../../../validations/form-validation-service'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { LimitLengthTextFieldValidator } from '../../../validations/limit-value-text-field-validator'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { User_details, UserAddressDB, UserLicense, BgCheck } from '../../models/user-details'
import { UserProfile } from '../../models/user-profile'
import { UserProfileRoleOrganization } from '../../models/user-profile-role-org'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { PortalGlobals } from '../../../portalglobals'
import { WebUserComment } from '../../models/web-user-comments'
import { License } from '../../models/license-details'
import * as moment from 'moment'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
import { CommonGateway } from '../../../common/gateways/common-gateway'
import { LicenseApptGateway } from '../../gateways/license-appt-gateway'
import { UserCommentsGateway } from '../../gateways/user-comments-gateway'
import { UserGateway } from '../../gateways/user-gateway'
import { OrgSettingsModel } from '../../../org-management/models/org-settings-model'
import { AddressType } from '../../../common/models/addresstype'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'UserSearchDetail',
    templateUrl: 'user-details.component.html',
    styleUrls: ['../user.component.scss']
})
export class UserSearchDetailComponent implements OnInit {
    user: any = {} as any
    disableLogIn: boolean = true
    userDetails: User_details
    userProfile: UserProfile
    userOrgRoleDetails: UserProfileRoleOrganization
    userBackGroundCheck: BgCheck
    displayEmpID: boolean
    residentialAddress: UserAddressDB
    businessAddress: UserAddressDB
    phoneNum: string
    cellNum: string
    showEcontract: boolean
    eContractOnFile: ValidatedSelectOptionModel[] = []
    textMsgOptIn: ValidatedSelectOptionModel[] = []
    isRequired: boolean
    selectedUserprofileID: number
    loading: boolean = true
    showCommentsTab = false
    showLicenseTab = false
    showTrainingTab = false
    commentsScreenShow = false
    licenseScreenShow = false
    trainingScreenShow = false
    commentsViewModel: WebUserComment[] = [] as WebUserComment[]
    licenseViewModel: License[] = [] as License[]
    BackgroundcheckResult: string
    orgListString: string
    userOrgId: number
    userOrgName: string
    phoneNumberInputMask = new PhoneNumberInputMask()
    isOrgCommissionable: boolean
    isEContracting: boolean
    isTextOptInAvailale: boolean
    insCompOrgId: number
    isHomeAddressTypeAllowed: boolean = false
    homeAddressTypeCustomName: string | undefined
    isBusinessAddressTypeAllowed: boolean = false
    businessAddressTypeCustomName: string | undefined
    showBgcData: boolean
    showAppt: boolean
    showUserStatusInSettings: boolean
    viewprofile: boolean = false
    Editviewprofile: boolean = false
    isAllowEditUserforRole: boolean
    isChangePassword: boolean

    constructor(
        private routers: Router,
        private route: ActivatedRoute,
        public _global: PortalGlobals,
        private userProfileGateway: UserProfileGateway,
        private _commonGateway: CommonGateway,
        private licenseApptGateway: LicenseApptGateway,
        private userCommentsGateway: UserCommentsGateway,
        private _userGateway: UserGateway,
        private _networkUserAccessGateway: UserAccessGateway
    ) {
        // super(formValidationService)
        // this.onInit()
    }

    ngOnInit(): void {
        this.loading = true
        this.userDetails = {} as User_details
        this.userProfile = {} as UserProfile
        this.userOrgRoleDetails = {} as UserProfileRoleOrganization
        this.residentialAddress = {} as UserAddressDB
        this.businessAddress = {} as UserAddressDB
        this.userBackGroundCheck = {} as BgCheck
        this.displayEmpID = false
        this.showEcontract = true
        this.eContractOnFile = [
            { value: '1', text: 'Yes' },
            { value: '0', text: 'No' }
        ]
        this.textMsgOptIn = [
            { value: '1', text: 'Yes' },
            { value: '0', text: 'No' }
        ]

        this.route.params.subscribe((params) => {
            if (params['userProfileID'] !== undefined && params['view'] === undefined && params['Editview'] === undefined) {
                this.selectedUserprofileID = Number(params['userProfileID'])
                this.setPageData()
            } else if (params['userProfileID'] !== undefined && params['view'] !== undefined) {
                /**
                        comments: NA- 05-23-2019
                        Checking the Aetna org users for showing the Producer World link and hide the Edit and Back buttons
                    */
                this.viewprofile = params['view']
                this.selectedUserprofileID = Number(params['userProfileID'])
                this.setPageData()
            } else if (params['userProfileID'] !== undefined && params['Editview'] !== undefined) {
                /**
                        comments: NA- 05-23-2019
                        Checking the Aetna org users for showing the Producer World link and hide the Edit and Back buttons
                    */
                this.Editviewprofile = params['Editview']
                this.selectedUserprofileID = Number(params['userProfileID'])
                this.setPageData()
            }
        })
        this.isChangePassword = this._global.currentUser.insuranceCompanyName === this._global.insuranceCompanyNameSSI
    }

    Pwurl() {
        this.userProfileGateway.GetPWurl().subscribe((model) => {
            window.open(model, '_blank')
        })
    }
    Cancel() {
        if (this.Editviewprofile) {
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.routers.navigate(['/' + insCo + '/user-management/user-list/user-search'])
        }
    }

    setPageData() {
        this.showEcontract = true
        this.userProfileGateway.getUserAllDetails(this.selectedUserprofileID, String(this._global.selectedPlanYear)).subscribe(
            (model: User_details) => {
                this.userDetails = model
                this.userProfile = model.UserProfile
                this.userOrgRoleDetails = model.UserProfileRoleOrganization
                this.userBackGroundCheck = model.BackGroundCheck

                this.userBackGroundCheck.BGCheck = model.BackGroundCheck.BgAuthorized === 1 ? 'Yes' : 'No'
                this.userBackGroundCheck.BackGroundCheckDate = model.BackGroundCheck.BgAuthorizedDate

                if (this.userBackGroundCheck.BackGroundCheckDate !== null) {
                    this.userBackGroundCheck.BackGroundCheckDateStr = moment(this.userBackGroundCheck.BackGroundCheckDate)
                        .subtract(7, 'h')
                        .format('MM/DD/YYYY')
                        .toString()
                } else {
                    this.userBackGroundCheck.BackGroundCheckDateStr = ''
                }

                this.userOrgId = model.UserProfile.OrgID
                this.userOrgName = model.UserProfile.OrgName

                /**
                 comments: NA- 05-23-2019
                 Checking the Aetna org users for showing the Producer World link and hide the Edit and Back buttons
                 */
                this._networkUserAccessGateway.IsAllowtoEditUser(this._global.currentUser.userProfileName).subscribe((isallow: boolean) => {
                    this.isAllowEditUserforRole = isallow
                    if (this.isAllowEditUserforRole !== undefined && this.isAllowEditUserforRole !== null) {
                        if (this.isAllowEditUserforRole === true) {
                            this.viewprofile = false
                        } else if (this.isAllowEditUserforRole === false) {
                            if (this.userProfile.LockEditUsers === true) {
                                this.viewprofile = true
                            }
                        }
                    } else {
                        if (this.userProfile.LockEditUsers === true) {
                            this.viewprofile = true
                        }
                    }
                })

                this.displayEmpID = this.userProfile.UserLoginType === 'Internal' ? true : false
                let UserTypeDesc = this.userDetails.UserProfileRoleOrganization.RoleDefinitionID.toString()
                if (UserTypeDesc === 'Agent: Marketing' || UserTypeDesc === 'Admin-Agent') {
                    this.isRequired = true
                } else {
                    this.isRequired = false
                }

                //if (!(UserTypeDesc === 'Super Admin SMM' || UserTypeDesc === 'Super Admin SMA'
                //    || UserTypeDesc === 'Admin: Super' || UserTypeDesc === 'Org Manager'
                //    || UserTypeDesc === 'eViewer' || UserTypeDesc === 'Auditor' || UserTypeDesc === 'Admin: Guru')) {
                //    this.showEcontract = true
                //}

                if (this.userDetails !== undefined && this.userDetails !== null) {
                    if (this.userDetails.Address !== undefined && this.userDetails.Address !== null && this.userDetails.Address.length > 0) {
                        this.residentialAddress = this.userDetails.Address.filter((x) => x.AddressType === 'Home')[0]
                        this.businessAddress = this.userDetails.Address.filter((x) => x.AddressType === 'Business')[0]
                    }

                    if (this.userDetails.UserPhones !== undefined && this.userDetails.UserPhones !== null && this.userDetails.UserPhones.length > 0) {
                        let phoneDB = this.userDetails.UserPhones.filter((x) => x.PhoneType === 'Business')[0]
                        let cellDB = this.userDetails.UserPhones.filter((x) => x.PhoneType === 'Cell')[0]
                        if (phoneDB !== undefined && phoneDB !== null && phoneDB.Phone !== undefined && phoneDB.Phone !== null) {
                            this.phoneNum = phoneDB.Phone
                        }
                        if (cellDB !== undefined && cellDB !== null && cellDB.Phone !== undefined && cellDB.Phone !== null) {
                            this.cellNum = cellDB.Phone
                        }
                    }
                }
                let orgList = ''
                this._commonGateway.getOrgIPV(this.userOrgId).subscribe((orgIPV: number[]) => {
                    if (orgIPV != null) {
                        if (orgIPV[0] === undefined || orgIPV[0] === null) {
                            this.insCompOrgId = this.userOrgId
                        } else {
                            this.insCompOrgId = orgIPV[0]
                        }
                        this.getInsCompFMOSettings()
                        this.getInsCompValidAddressTypes()
                        for (var org of orgIPV) {
                            orgList += org + '.'
                        }
                        orgList = orgList + this.userOrgId.toString()

                        this._commonGateway.getIPVString(orgList).subscribe((model: string) => {
                            let insComp = ''
                            if (model != null && model != '') {
                                this.orgListString = model + ' > ' + this.userOrgName
                                insComp = model.split('>')[0].trim()
                            } else {
                                this.orgListString = this.userOrgName
                                insComp = this.userOrgName
                            }

                            if (insComp.toUpperCase() === 'BLUE MEDICARERX (PDP)') {
                                this.showUserStatusInSettings = true
                            }
                        })
                    }
                })

                this.showCommentsTab = true
                this.showLicenseTab = true
                this.showTrainingTab = true
                this.loading = false
            },
            (error) => {
                this.loading = false
            }
        )
    }

    getInsCompFMOSettings() {
        this.licenseApptGateway.getFMOSettings(this.insCompOrgId.toString()).subscribe((data: OrgSettingsModel[]) => {
            let res = data.find((x) => x.SettingName.toUpperCase() === 'SHOW APPOINTMENT')
            if (res === undefined || res === null) {
                this.showAppt = false
            } else {
                if (res.SettingValue.toUpperCase() === 'YES') {
                    this.showAppt = true
                } else {
                    this.showAppt = false
                }
            }
        })
        this._userGateway.getFMOSettings(this.insCompOrgId).subscribe((orgSettingData: OrgSettingsModel[]) => {
            let commissionable = orgSettingData.find((x) => x.SettingName.toUpperCase() === 'COMMISSIONABLE')?.SettingValue
            if (commissionable === null || commissionable === undefined) {
                this.isOrgCommissionable = false
            } else if (commissionable.toUpperCase() === 'NO') {
                this.isOrgCommissionable = false
            } else {
                this.isOrgCommissionable = true
            }

            let econtract = orgSettingData.find((x) => x.SettingName.toUpperCase() === 'E-CONTRACTING')?.SettingValue
            if (econtract === null || econtract === undefined) {
                this.isEContracting = false
            } else if (econtract.toUpperCase() === 'NO') {
                this.isEContracting = false
            } else {
                this.isEContracting = true
            }

            let txtoptin = orgSettingData.find((x) => x.SettingName.toUpperCase() === 'TEXT MESSAGE OPT IN')?.SettingValue

            if (txtoptin === null || txtoptin === undefined) {
                this.isTextOptInAvailale = false
            } else if (txtoptin.toUpperCase() === 'NO') {
                this.isTextOptInAvailale = false
            } else {
                this.isTextOptInAvailale = true
            }
        })

        this._userGateway.getBackGroundCheckSetting(this.insCompOrgId).subscribe((orgSettingData: OrgSettingsModel[]) => {
            let val = orgSettingData.find((x) => x.SettingName.toUpperCase() === 'BACKGROUNDCHECK')?.SettingValue
            if (val === null || val === undefined) {
                this.showBgcData = false
            } else if (val.toUpperCase() === 'NO') {
                this.showBgcData = false
            } else {
                this.showBgcData = true
            }
        })
    }

    getInsCompValidAddressTypes() {
        this._userGateway.getInsCompValidAddressTypes(this.insCompOrgId).subscribe((data: AddressType[]) => {
            let HomeAddress = data.find((x) => x.AddressType.toUpperCase() === 'HOME')
            if (HomeAddress === null || HomeAddress === undefined) {
                this.isHomeAddressTypeAllowed = false
            } else {
                let homeAddressTypeName = data.find((x) => x.AddressType.toUpperCase() === 'HOME')?.AddressTypeName
                if (homeAddressTypeName?.trim() === '') {
                    this.homeAddressTypeCustomName = 'Residential Address'
                    this.isHomeAddressTypeAllowed = true
                } else {
                    this.isHomeAddressTypeAllowed = true
                    this.homeAddressTypeCustomName = homeAddressTypeName
                }
            }

            let BusinessAddress = data.find((x) => x.AddressType.toUpperCase() === 'BUSINESS')
            if (BusinessAddress === null || BusinessAddress === undefined) {
                this.isBusinessAddressTypeAllowed = false
            } else {
                let businessAddressTypeName = data.find((x) => x.AddressType.toUpperCase() === 'BUSINESS')?.AddressTypeName
                if (businessAddressTypeName?.trim() === '') {
                    this.businessAddressTypeCustomName = 'Business Address'
                    this.isBusinessAddressTypeAllowed = true
                } else {
                    this.isBusinessAddressTypeAllowed = true
                    this.businessAddressTypeCustomName = businessAddressTypeName
                }
            }

            //let businessAddressTypeName =  data.find(x => x.AddressType.toUpperCase() === "BUSINESS").AddressTypeName
            //if(businessAddressTypeName === null || businessAddressTypeName === undefined){
            //    this.isBusinessAddressTypeAllowed = false
            //}else if(businessAddressTypeName.trim() === ""){
            //    this.homeAddressTypeCustomName = "Business Address"
            //    this.isBusinessAddressTypeAllowed = true
            //}else{
            //    this.isBusinessAddressTypeAllowed = true
            //    this.businessAddressTypeCustomName = businessAddressTypeName
            //}
        })
    }

    onInit() {}

    back() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigate(['/' + insCo + '/user-management/user-search'])
    }

    editProfile() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this._global.currentUser.insuranceCompanyName === this._global.insuranceCompanyNameSSI)
            this.routers.navigate(['/' + insCo + '/user-management/edit-user/edit/' + this.selectedUserprofileID + '/' + true])
        //replace this hardcoded with getparams from url
        else this.routers.navigate(['/' + insCo + '/user-management/neje/add-profile/edit/' + this.selectedUserprofileID + '/' + true])
    }

    changePwdNavigation() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this._global.currentUser.insuranceCompanyName === this._global.insuranceCompanyNameSSI) {
            this.routers.navigate(['/' + insCo + '/user-management/update/' + this.selectedUserprofileID])
        } // else {
        //    this.routers.navigate(['/' + insCo + '/user-management/reset/' + this.selectedUserprofileID])
        //}
    }

    showTabbed(screen: number) {
        this.commentsScreenShow = false
        this.licenseScreenShow = false
        this.trainingScreenShow = false
        if (screen === 1) {
            this.commentsScreenShow = true
            this.getUserComments()
        }
        if (screen === 3) {
            this.trainingScreenShow = true
        }
        if (screen === 2) {
            this.licenseScreenShow = true
            this.getUserLicense()
        }
    }

    getUserComments() {
        // this.commentsViewModel = this.userDetails.comments
        this.userCommentsGateway.getUserCommentsData(this.selectedUserprofileID).subscribe((model: WebUserComment[]) => {
            this.commentsViewModel = model
        })
    }

    //getUserLicense() {

    //    this.licenseViewModel = this.userDetails.LicenseDetails
    //    this.licenseViewModel.forEach((licenses) => {
    //        if (licenses.LicenseExpirationDate !== null) {
    //            licenses.LicenseDate = (moment(licenses.LicenseExpirationDate)).format('MM/DD/YYYY').toString()
    //        }
    //        if (licenses.AppointmentTerminationDate !== null) {
    //            licenses.ExpirationDate = (moment(licenses.AppointmentTerminationDate)).format('MM/DD/YYYY').toString()
    //        }
    //        if (licenses.AppointmentEffectiveDate !== null) {
    //            licenses.Effectivedate = (moment(licenses.AppointmentEffectiveDate)).format('MM/DD/YYYY').toString()
    //        }

    //        licenses.EditRow = false
    //    })
    //}

    getUserLicense() {
        this.licenseApptGateway.getUserLicenseDetails(this.selectedUserprofileID).subscribe((model: License[]) => {
            this.licenseViewModel = model
            this.licenseViewModel.forEach((licenses) => {
                if (licenses.LicenseExpirationDate !== null) {
                    licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                }
                if (licenses.AppointmentTerminationDate !== null) {
                    licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                }
                if (licenses.AppointmentEffectiveDate !== null) {
                    licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                }
                licenses.EditRow = false
            })
        })
    }
}
